import {
  type HtmlPageOrientation,
  type HtmlPagePaper,
  type HtmlPageWidth,
  htmlPagePaperGeometry,
  htmlPageSheetGeometry,
  htmlPageWidthLabel,
  NAMED_PAPERS,
  ORIENTATION_LABELS,
} from '@app/shared'

export {
  type HtmlPagePaperGeometry,
  htmlPagePaperGeometry,
  htmlPageSheetGeometry,
} from '@app/shared'

/**
 * A paper's size as the sheet prints it. A custom paper's two sides are a pair
 * with no order of their own, so its size is stated across then down, after the
 * orientation has placed them.
 */
export function htmlPagePaperLabel(
  paper: HtmlPagePaper | null,
  orientation: HtmlPageOrientation,
  width: HtmlPageWidth = 'full',
): string {
  if (!paper)
    return width === 'full'
      ? 'Screen page'
      : `Screen page, ${htmlPageWidthLabel(width)}`
  if (paper.name !== 'custom') return NAMED_PAPERS[paper.name].label
  const sheet = htmlPageSheetGeometry(htmlPagePaperGeometry(paper), orientation)
  return sheet
    ? `${sheet.widthMm} × ${sheet.heightMm} mm`
    : `${paper.widthMm} × ${paper.heightMm} mm`
}

export function htmlPageSheetLabel(
  paper: HtmlPagePaper | null,
  orientation: HtmlPageOrientation,
  width?: HtmlPageWidth,
): string {
  const label = htmlPagePaperLabel(paper, orientation, width)
  return paper
    ? `${label}, ${ORIENTATION_LABELS[orientation].toLocaleLowerCase()}`
    : label
}
